export enum EQuarters {
  TOP_LEFT = 'top_left',
  TOP_RIGHT = 'top_right',
  BOTTOM_LEFT = 'bottom_left',
  BOTTOM_RIGHT = 'bottom_right'
}

export enum EMountHandlers {
  MOUNT = 'mount',
  UNMOUNT = 'unmount'
}
